<template>
    <HeaderContent title="Database Backup" />
  
    <ActionContent
      :cta="true"
      cta-text="Generate Backup"
      :filter-modal="false"
      @action="handleGenerate"
      :show-search="false"
      :show-date-filter="false"
    />
  
    <DataTable
      :data="backups"
      :header="headers"
      :customActions="customActions"
    />
  
    <ToastResponse
      v-model="modalResponse.toast"
      :text="modalResponse.text"
      :success="modalResponse.success"
    >
    </ToastResponse>
  </template>
  
  <script>
  import { ref, inject, onMounted } from "vue";
  import HeaderContent from "@/components/HeaderContent.vue";
  import ActionContent from "@/components/ActionContent.vue";
  import DataTable from "@/components/DataTable.vue";
  import ToastResponse from "@/components/ToastResponse.vue";
  
  export default {
    components: {
      HeaderContent,
      ActionContent,
      DataTable,
      ToastResponse,
    },
    setup() {
      const repositories = inject("repositories");
      const backupRepository = repositories?.backup;
  
      const backups = ref([]);
      const modalResponse = ref({ toast: false, text: "", success: false });
  
      const headers = ref([
        {
          key: "no",
          label: "No",
          sortable: true,
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "name",
          label: "File Name",
          sortable: true,
        },
        {
          key: "size",
          label: "Size",
          sortable: true,
        },
        {
          key: "date",
          label: "Creation Date",
          sortable: true,
        },
        {
          key: "action",
          label: "Actions",
          tdClass: "text-center",
          thClass: "text-center",
        },
      ]);
  
      const customActions = ref([
        {
          label: "Download",
          icon: "fas fa-download",
          variant: "primary",
          action: async (item) => {
            try {
              const res = await backupRepository.downloadBackup(item.name);
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', item.name);
              document.body.appendChild(link);
              link.click();
              link.parentNode.removeChild(link);
            } catch (error) {
              console.error(error);
              modalResponse.value = {
                toast: true,
                text: "Failed to download backup",
                success: false,
              };
            }
          },
        },
        {
          label: "Delete",
          icon: "fas fa-trash",
          variant: "danger",
          action: async (item) => {
            if (!confirm(`Are you sure you want to delete ${item.name}?`)) return;
            try {
              await backupRepository.deleteBackup(item.name);
              modalResponse.value = {
                toast: true,
                text: "Backup deleted successfully",
                success: true,
              };
              fetchBackups();
            } catch (error) {
              console.error(error);
              modalResponse.value = {
                toast: true,
                text: "Failed to delete backup",
                success: false,
              };
            }
          },
        },
      ]);
  
      const fetchBackups = async () => {
        try {
          const res = await backupRepository.getBackups();
          backups.value = res.data.data;
        } catch (error) {
          console.error(error);
        }
      };
  
      const handleGenerate = async () => {
        modalResponse.value = { toast: true, text: "Generating backup...", success: true };
        try {
          await backupRepository.createBackup();
          modalResponse.value = {
            toast: true,
            text: "Backup created successfully",
            success: true,
          };
          fetchBackups();
        } catch (error) {
          console.error(error);
          modalResponse.value = {
            toast: true,
            text: "Failed to create backup",
            success: false,
          };
        }
      };
  
      onMounted(() => {
        fetchBackups();
      });
  
      return {
        headers,
        backups,
        customActions,
        modalResponse,
        handleGenerate,
      };
    },
  };
  </script>
